function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.31213 15.347C8.92827 15.6941 8.89369 16.292 9.23491 16.6825C9.57612 17.073 10.1639 17.1081 10.5478 16.7611L17.2434 10.707C17.442 10.5275 17.5556 10.2702 17.5556 10C17.5556 9.7298 17.442 9.4725 17.2434 9.29299L10.5478 3.23895C10.1639 2.89186 9.57612 2.92703 9.23491 3.3175C8.89369 3.70797 8.92827 4.30588 9.31213 4.65296L14.1199 9L3.07692 9C2.79131 9 2.51739 9.10536 2.31542 9.29289C2.11346 9.48043 2 9.73478 2 10C2 10.2652 2.11346 10.5196 2.31542 10.7071C2.51739 10.8946 2.79131 11 3.07692 11L14.1199 11L9.31213 15.347Z",
  fill: "currentColor"
});

function SvgRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/Right.b3b6359c.svg";
export { ForwardRef as ReactComponent };